import React from "react";
import { useState, useEffect } from "react";
import {
    FaHeart,
    FaComment,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ProfileService from "../../../services/Profile";
import { useSelector } from "react-redux";
import { FaCoins, FaBitcoin, FaDollarSign, FaTrophy, FaGem, FaChartLine, FaRocket, FaCrown, FaBolt, FaStar } from "react-icons/fa6";



export default function NewPackages() {
    const { userData } = useSelector(state => state.user);
    const User = userData?.data?.finduser;
    // console.log("User Data:", User);


    const navigate = useNavigate();
    const [newPackages, setNewPackages] = useState([]);

    const getPackageIcon = (pkg) => {
        const name = pkg?.name?.toLowerCase() || '';

        if (name.includes('golden')
            //  || name.includes('') || name.includes('')
        ) {
            return {
                icon: <FaChartLine className="text-3xl text-white" />,
                bgColor: "bg-gradient-to-br from-amber-50 to-orange-50",
                bgIcon: "bg-gradient-to-br from-amber-400 to-orange-500",
                bgLabel: "bg-amber-500",
                bgSpan: "bg-amber-200/20"
            };
        }
        if (name.includes('silver')
            //  || name.includes('') || name.includes('')
        ) {
            return {
                icon: <FaRocket className="text-3xl text-white" />,
                bgColor: "bg-gradient-to-br from-blue-50 to-indigo-50",
                bgIcon: "bg-gradient-to-br from-blue-400 to-indigo-500",
                bgLabel: "bg-rose-500",
                bgSpan: "bg-blue-200/20"
            };
        }
        if (name.includes('platinum')
            //  || name.includes('') || name.includes('')
        ) {
            return {
                icon: <FaCrown className="text-3xl text-white" />,
                bgColor: "bg-gradient-to-br from-purple-50 to-pink-50",
                bgIcon: "bg-gradient-to-br from-purple-400 to-pink-500",
                bgLabel: "bg-purple-500",
                bgSpan: "bg-purple-200/20"
            };
        }
        if (name.includes('scalping')
            //  || name.includes('') || name.includes('')
        ) {
            return {
                icon: <FaBolt className="text-3xl text-white" />,
                bgColor: "bg-gradient-to-br from-emerald-50 to-teal-50",
                bgIcon: "bg-gradient-to-br from-emerald-400 to-teal-500",
                bgLabel: "bg-emerald-500",
                bgSpan: "bg-emerald-200/20"
            };
        }

        return {
            icon: <FaStar className="text-3xl text-white" />,
            bgColor: "bg-gradient-to-br from-gray-50 to-gray-50",
            bgIcon: "bg-gradient-to-br from-gray-400 to-gray-500",
            bgLabel: "bg-gray-500",
            bgSpan: "bg-gray-200/20"
        };
    };
    const [user, setUser] = useState(null);


    // const getAllPackages = async () => {
    //     try {
    //         const res = await ProfileService.getAllPackages({ type: 'signal' });
    //         setNewPackages(res?.data?.data)
    //         console.log("packages", res?.data?.data)
    //     } catch (err) {
    //         console.error("Error fetching packages:", err?.message || JSON.stringify(err))
    //     }
    // };
const getAllPackages = async () => {
    try {
        const res = await ProfileService.getAllPackages(); 
        const allPackages = res?.data?.data || [];
        const signalPackages = allPackages.filter(pkg => pkg.type === 'signal' || !pkg.type);
        setNewPackages(signalPackages);
        // console.log("Signal packages:", signalPackages);
    } catch (err) {
        console.error("Error fetching packages:", err?.message || JSON.stringify(err));
    }
};

    useEffect(() => {
        getAllPackages();
    }, []);




    // const handleLike = async (pkg) => {
    //     if (pkg?.isLiked) {
    //         const data = { packageId: pkg._id };
    //         console.log("Liking package:", data);
    //         const response = await ProfileService.disLikePackage(data);
    //         console.log("liked", response);
    //     }
    //     else {
    //         const data = { packageId: pkg._id };
    //         console.log("Disliking package:", data);
    //         const response = await ProfileService.likePackage(data);
    //         console.log("disLiked", response)
    //     }

    //     getAllPackages();
    // };

    return (
        <section id="new-packages" className="py-6">
            <div className="px-4 mb-4">
                <h2 className="text-xl font-bold">New Packages</h2>
            </div>

            <div className="flex gap-4 overflow-x-auto px-4 pb-2">
                {newPackages.map((pkg) => (
                    <div
                        key={pkg?._id}
                        onClick={() => navigate(`/signal/package/${pkg?._id}`)}
                        className={`relative overflow-hidden flex-shrink-0 w-64 ${getPackageIcon(pkg).bgColor} border-gray-200 rounded-2xl shadow-md p-4 flex flex-col justify-between cursor-pointer hover:shadow-lg transition-shadow duration-300`}
                    >
                        <span className={`z-0 absolute top-0 right-0 w-32 h-32 ${getPackageIcon(pkg).bgSpan} rounded-full -translate-y-16 translate-x-16`}></span>
                        <span className={`z-0 absolute bottom-0 left-0 w-24 h-24 ${getPackageIcon(pkg).bgSpan} rounded-full translate-y-12 -translate-x-12`}></span>
                        <div>
                            <div className="relative z-5 flex justify-between items-start mb-3">
                                <div className="flex items-center gap-2">
                                    <div className={`${getPackageIcon(pkg).bgIcon} w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg`}>
                                        {/* {getPackageIcon(pkg).icon} */}
                                        {pkg?.packageIcon === "coins" ? <FaCoins className="text-2xl text-white" />
                                            :
                                            pkg?.packageIcon === "bitcoin" ? <FaBitcoin className="text-2xl text-white" />
                                                :
                                                pkg?.packageIcon === "dollar" ? <FaDollarSign className="text-2xl text-white" />
                                                    :
                                                    pkg?.packageIcon === "crown" ? <FaCrown className="text-2xl text-white" />
                                                        :
                                                        pkg?.packageIcon === "rocket" ? <FaRocket className="text-2xl text-white" />
                                                            :
                                                            pkg?.packageIcon === "trophy" ? <FaTrophy className="text-2xl text-white" />
                                                                :
                                                                pkg?.packageIcon === "gem" ? <FaGem className="text-2xl text-white" />
                                                                    :
                                                                    pkg?.packageIcon === "star" ? <FaStar className="text-2xl text-white" />
                                                                        : null
                                        }
                                    </div>
                                    {/* <span className={`text-gray-600 bg-gray-200 text-xs px-2 py-1 rounded-full font-medium`}>
                                        {pkg?.label}
                                    </span> */}
                                </div>
                                <span className={`${getPackageIcon(pkg).bgLabel} text-white text-xs px-3 font-bold py-1 rounded-full`}>
                                    {pkg?.packageBadge}
                                </span>
                            </div>
                            <h3 className="text-xl font-bold text-gray-900">{pkg?.name}</h3>
                            <p className="text-gray-600 text-sm">{pkg?.description}</p>
                            <div className="flex items-center space-x-3 mt-2">
                                <div className="flex items-center space-x-1">
                                    <FaHeart
                                        // onClick={(e) => {
                                        //     e.stopPropagation();
                                        //     handleLike(pkg);
                                        // }}
                                        className={` text-sm transition-colors text-gray-400`} />
                                    <span className="text-gray-600 text-sm">{Array.isArray(pkg?.likeCount) ? pkg?.likeCount?.length : pkg?.likeCount || 0}</span>
                                </div>
                                <div className="flex items-center space-x-1">
                                    <FaComment className="text-gray-400 text-sm" />
                                    <span className="text-gray-600 text-sm">{pkg?.commentCount || 0}</span>
                                </div>
                            </div>
                        </div>

                        <div className="space-y-2.5 text-gray-800 relative bg-white/60 backdrop-blur-sm rounded-2xl p-4">
                            <div className="flex justify-between items-center text-sm">
                                <span className="text-gray-600 font-medium">Signals/Month</span>
                                <span className="font-bold text-gray-900">95</span>
                            </div>
                            <div className="flex justify-between items-center text-sm">
                                <span className="text-gray-600 font-medium">Monthly Profit</span>
                                <span className="font-bold text-emerald-600">+16.2%</span>
                            </div>
                            <div className="flex justify-between items-center text-xs">
                                <span className="text-gray-500">vs Last Month</span>
                                <span className="font-semibold text-emerald-600">+2.1%</span>
                            </div>
                        </div>

                    </div>
                ))}
            </div>
        </section>
    );
}
